import { render, staticRenderFns } from "./CalendarTermDialogForEdit.vue?vue&type=template&id=ab53cfa8&scoped=true&"
import script from "./CalendarTermDialogForEdit.vue?vue&type=script&lang=js&"
export * from "./CalendarTermDialogForEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab53cfa8",
  null
  
)

export default component.exports